import cn from '#/utils/classnames'
import { SpinnerProps } from '../types'
import styles from './styles.module.scss'

export default function Hexagon({ className, color, size }: SpinnerProps) {
  return (
    <div className={cn('th-hexagon-loader', className)}>
      <div className={cn(styles.preloader, styles.loading)}>
        {[1, 2, 3, 4, 5, 6].map(e => <span key={e} className={styles.slice} />)}
      </div>

      <style jsx>
        {`
        .th-hexagon-loader {
          margin: auto;
          width: ${size}px;
          height: ${size}px;
          position: relative;
          transform: scale(${size / 48});

          --spinner-color: ${color};
          --spinner-size: ${size / 16 * 3}px;
        }
      `}
      </style>
    </div>
  )
}

Hexagon.defaultProps = {
  color: '#6651f5',
  size: 64
}
